import React from 'react';

import { Alert, Tag, Typography } from 'antd';

interface IProps {
  type: string;
  pixels: any;
}

const TagmanagerAlert = (props: IProps) => {
  const { type, pixels } = props;

  if (type === 'tagmanager' && pixels.filter((t: any) => t.type !== 'tagmanager').length > 0) {
    return (
      <Alert
        className='mb-5'
        type='warning'
        showIcon
        description={
          <Typography.Text>
            Você já possuí o{' '}
            <Tag>
              {pixels
                .filter((item: any) => item.type !== 'tagmanager')
                .map((item: any) => item.type)
                .join(', ')}
            </Tag>
            , ao instalar o <Tag>Google Tag Manager</Tag> você pode causar duplicidade de pixels. Você tem certeza que
            sabe o que está fazendo?
          </Typography.Text>
        }
      />
    );
  }

  if (type !== 'tagmanager' && pixels.find((t: any) => t.type === 'tagmanager')) {
    return (
      <Alert
        className='mb-5'
        type='warning'
        showIcon
        description={
          <Typography.Text>
            Você já possuí o <Tag>Google Tag Manager</Tag> instalado, ao instalar o <Tag>{type}</Tag> você pode causar
            duplicidade de pixels. Você tem certeza que sabe o que está fazendo?
          </Typography.Text>
        }
      />
    );
  }

  return null;
};

export default TagmanagerAlert;
